import { render } from "./SupplierDetailSummaryTab.vue?vue&type=template&id=6188be1b"
import script from "./SupplierDetailSummaryTab.vue?vue&type=script&lang=js"
export * from "./SupplierDetailSummaryTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__